import React from 'react';
import { Button } from 'react-bootstrap';

const Error = ({ onRetry }) => (
    <div className='text-center'>
        <h3>Ups, a aparut o eroare!</h3>
        {renderRetry(onRetry)}
    </div>
);

const renderRetry = (onRetryCallback) => {
    const onClickCallback = typeof (onRetryCallback) !== 'function' ? defaultRetryCallback : onRetryCallback;

    return (
        <Button variant='primary' onClick={onClickCallback}>
            Incearca din nou
        </Button>
    );
};

const defaultRetryCallback = () => {
    window.location.reload();
};

export default Error;
